<script>
  export let svgClass = "";
  export let strokecolor ="#6C757D"
</script>
<svg class={svgClass} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M18 6L6 18" stroke={strokecolor} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6 6L18 18" stroke={strokecolor} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>